<template>
  <div class="container">
  <FinancialData/>
  

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Student Account</div>
          <div class="panal-body" v-if="AccountDetails.length > 0">
            <b-row>
              <b-col cols="6" class="mb-2">
                <strong>Creation Date</strong>
                <span class="text-primary"> {{AccountDetails[0].CreationDate | moment("ll") }} </span>
              </b-col>

              <b-col cols="6" class="mb-2">
                <strong>No. Of Approved Transaction</strong>
                <span class="text-primary"> {{AccountDetails[0].NoOfApproved}}</span>
              </b-col>

              <b-col cols="6" class="mb-2">
                <strong>No. Of Pending Transaction</strong>
                <span class="text-primary"> {{AccountDetails[0].NoOfPending}}</span>
              </b-col>

              <b-col cols="6">
                <strong>No. Of Void Transaction</strong>
                <span class="text-primary"> {{AccountDetails[0].NoOfVoid}}</span>
              </b-col>

              <b-col cols="6">
                <strong>Last Deposit Date </strong>
                <span class="text-primary">{{AccountDetails[0].LastDebositDate  | moment("ll") }}</span>
              </b-col>

              <b-col cols="6">
                <strong>Pending Credit</strong>
                <span class="text-primary"> {{AccountDetails[0].PendingCredit}}</span>
              </b-col>

           
         
            </b-row>
          </div>
        </div>
      </div>
    </div>
   <div class="bg-filter">
   <div class="row ">     
    <div class="col-md-10">
<label >Payment Method</label>
<!-- :options="options" -->
   <b-form-select v-model="search"  >
     
     <option v-for="payment in paymentMethods" :key="payment.serial" :value="payment.AmountTypeName">
          {{payment.AmountTypeName}}
     </option>
   </b-form-select>
   

    </div>

    <!-- <div class="col-md-5">

    <label >Payment Date</label>
  <b-form-datepicker id="End" class="mb-2"></b-form-datepicker>
  

    </div> -->
<div class="col-md-2 align-middle mt-4">
   <span class="align-middle">
     <b-button variant="success mt-2">Search</b-button>
   </span>
    </div>
    </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Text Title</div>
          <div class="panal-body">

<!-- <input type="text" v-model="search" placeholder="search Method" /> -->


            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Payment Date</th>
                    <th scope="col">Value</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Payment Method</th>

                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                   <tr v-if="empty"><td colspan="7"> No Data </td></tr>
                  <tr v-else v-for="item in filteredMethod" v-bind:Key="item.PaymentDetailsID">
                    <td>{{item.PaymentDate}}</td>

                    <td>{{item.Amount}}</td>

                    <td>{{item.PaymentStatus}}</td>
                    <td>{{item.PaymentMethod}}</td>
                    <td>
                      <!-- v-b-modal.Bank 
                      
                       @click="openmodel(Bank.id)" id="show-modal"   v-b-modal.Bank 
                      
                      -->
                      <b-button variant="primary" @click="getdit(item, item.PaymentMethod)"
                       >View Details</b-button
                      >

           

                    </td>
                  </tr>
             <b-modal id="Bank" title="Bank Details"  name="Bank">
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Bank Branch</th>
                              <th scope="col">Deposit Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="empty"><td colspan="4"> No Data </td></tr>
                            <tr v-else v-for="(item,index) in actionsAdvanced" v-bind:Key="index">
                              <td>{{item.ReceiptNumber}}</td>

                              <td>{{item.Bank}}</td>
                              <td>{{item.BankBranch}}</td>

                              <td>{{item.Bank_DepositDate}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>

<b-modal id="Cash" title="Cash Details"  name="Cash" >
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">save box</th>
                            </tr>
                          </thead>

                          <tbody>
                              <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>

                              <td>{{item.savebox}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>


<b-modal id="Cheque"  title="Cheque Details" >
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Bank Name</th>
                              <th scope="col">Bank Branch</th>
                              <th scope="col">DueDate</th>
                              <th scope="col">Check Number</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>

                              <td>{{item.Bank}}</td>
                              <td>{{item.BankBranch}}</td>

                              <td>{{item.DueDate}}</td>
                              <td>{{item.CheckNumber}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>


  <b-modal id="Transfer" title="Transfer Details">
                        <table class="table mt-3 table-bordered">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">Recipt Number</th>
                              <th scope="col">Swift Code</th>
                              <th scope="col">Transfer date</th>
                           
                            </tr>
                          </thead>

                          <tbody>
                             <tr v-if="empty"><td colspan="2"> No Data </td></tr>
                            <tr v-else v-for="item in actionsAdvanced" v-bind:Key="item.StudentID">
                              <td>{{item.ReceiptNumber}}</td>

                              <td>{{item.SwiftCode}}</td>
                              <td>{{item.Transferdate}}</td>

                          
                            </tr>
                          </tbody>
                        </table>
                      </b-modal>                    
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FinancialData from "../../components/Financial/FinancialData.vue";
import studentData from '../../services/student/studentDataServices';
export default {
     components: {
      FinancialData,
  
  },
  
  name: "CashReceipt",
  data() {
    return {
      selected: null,
      show: true,
      AccountDetails:'',
      StudentTransactions:[],
      actionsAdvanced:'',
      search:null,
      model:'',
      name:'',
      empty: false,
      isHidden: false,
      paymentMethods: [],
      options: [
          { value: null, text: 'Select Method',},
          { value: 'Cash', text: 'Cash' },
          { value: 'Bank', text: 'Bank' },
          { value: 'Cheque', text: 'Cheque' },
          { value: 'Transfer', text: 'Transfer' },

     ],
     
    };
  },
  computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
          filteredMethod: function(){
            
          return this.StudentTransactions.filter((item) =>{
            if (this.search == null) {
              return item
            }
            return item.PaymentMethod == this.search;
          });
},
         

       },
  mounted(){
        
      //this.currenUser.StudentID // 4
            studentData.GetStudentAccountDetails(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
                // eslint-disable-next-line no-console
                  console.log('AccountDetails => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),

              //this.currenUser.StudentID // 4
            studentData.GetStudentTransactions(this.currenUser.StudentID,0,'1/1/0001').then(Response =>{
              // this.isLoading = false ;

               this.StudentTransactions = Response.data
                // eslint-disable-next-line no-console
                  console.log('StudentTransactions => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })

          //        //this.currenUser.StudentID
          //   studentData.GetStudentTransactionsAdvanced(4,677,'false' ,'true' ,'false' ,'false').then(Response =>{
          //     // this.isLoading = false ;
          //      this.actionsAdvanced = Response.data
          //       // eslint-disable-next-line no-console
          //         console.log(Response.data)
          //  }, error => {
              
          //         // eslint-disable-next-line no-console
          //         console.log(error.response.status)
                 
          //     this.message =
          //       (error.response && error.response.data && error.response.data.Message) ||
          //       error.message ||
          //       error.toString();
                
          //       if(error.response.status == 404) this.message =''
             
          //   })


       studentData.GetPaymentMethods().then(Response =>{
              // this.isLoading = false ;
               this.paymentMethods = Response.data
                // eslint-disable-next-line no-console
                  console.log('Payment Methods => ',Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })      
    },


      methods: {

  getdit(item, paymentMethod){
      /* eslint-disable no-console */
      console.log("works")
     
          this.currentItem  = item;
          
          //this.currenUser.StudentID,item.CourseID,item.RoleReviewID
          //studentData.GetStudentTransactionsAdvanced(4,677,'false' ,'true' ,'false' ,'false').then(
          studentData.GetStudentTransactionsAdvanced(this.currenUser.StudentID,item.PaymentDetailsID,item.IsCash ,item.IsBank ,item.IsTransfer ,item.IsCheque).then(
             (Response) => {
          this.isLoading = false;
          this.empty = false
          this.actionsAdvanced = Response.data;
           this.$bvModal.show(paymentMethod);
          // eslint-disable-next-line no-console
          console.log('Advanced => ',this.PaymentMethod);
        },
        (error) => {
          // eslint-disable-next-line no-console
          console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      
          )
    },




    // set active modal and set index wich content is activeted
    modalOpen() {
  
      // if(("#").length == Bank){
        
      //    this.showModal = true; 

      // }
      // else if(("#") ==Cash){
      //    this.showModal = true; 

      // }  
  // return this.active = i;
          //this.showModal = true; 
//this.$refs.showModal.show()
          return this.StudentTransactions.filter((item) =>{
          return item.PaymentMethod.match(this.id);
         
});




      },


  }

      
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
.badge {
  padding: 0.65em 0.6em;
}
</style>
